module.exports = __webpack_public_path__ + "img/CM.1c57fccc.png";